<template lang="pug">
include /mixins
+b.product-group-preview(
  :class='{"is-active": !!quantity, "has-error": error, "has-global-error": globalError}'
)
  +e.img-wrap()
    +e.img.IMG(
      v-if='item.weight.props.img'
      :src='item.weight.props.img',
      :alt='item.product.title',
      :title='item.product.title',
    )
    +e.color(
      :style='{ background: item.weight.props.color }',
      v-else
    )
  +e.number.P {{ item.weight.props.color_number }}
  +e.title.P {{ item.weight.props.name }}
  BtnsController(:t='item.price_definition.user.unavailable')
    template(#default='{ has_no_contract_btn, has_cosmetologist_btn, has_cart_btn, has_out_of_stock_btn, show_cosmetologist_desc, show_price }')
      div
        counter(
          :amount='quantity',
          :min-count='0'
          @input='updateQuantity'
          v-if='item.stock && has_cart_btn'
        )
          //- :max-count='item.stock - item.stock_in_cart'
        modal-trigger(
          v-if="has_cosmetologist_btn"
          url='UiElements/CosmetologPermissions',
          name='CosmetologPermissions',
          :classes='["cart-modal"]'
          subtitle_auth="true",
        )
          template(#default='{ open }')
            +b.tt-button--mini.--appearance_free.tt-space_mb--2.BUTTON(
              @click='open()',
            )
              +e.title.P {{ _('Повысить уровень') }}
        modal-trigger(
          v-else-if="has_no_contract_btn"
          url='UiElements/AccessPriceRequest',
          name='AccessPriceRequest',
          :classes='["defaultModal"]'
          subtitle_auth="true",
          :brand="item.product.brand.id"
          :user_name='username || ""'
          :user_phone='phone || "" '
        )
          template(#default='{ open }')
            +b.tt-button--mini.--appearance_free.--bordered_primary.product-preorder.tt-space_mb--2.BUTTON(
              @click='open()',
            )
              +e.title.P {{ _('Заключить контракт') }}
        modal-trigger(
          v-if='has_out_of_stock_btn'
          :user_name='username'
          :user_phone='phone'
          url='Preorder/Modal',
          name='PreOrderModal',
          :id='item.id'
          :can_order='false'
          :img='item.weight.props.img || "https://via.placeholder.com/150x150"'
          :maintitle='item.product.title'
          :description='item.product.short_description'
          :weight='item.weight.props.name'
          :stock='item.stock'
          :type='item.type',
          v-slot="{ open }"
          :classes='["videoModal"]'
          :price='getPrice()'
        )
          +b.tt-button--mini.--appearance_free.--bordered_primary.product-preorder.tt-space_mb--2.BUTTON(
            @click.prevent='open()'
          )
            +e.title.P {{ _('Предзаказ') }}
          //- :show-error='stockInfo && !stockInfo.is_valid && stockInfo.quantity > stockInfo.stock_quantity_1c'
          //- :variant='product.element.id'
          //- :key='`${product.id}_${price}`'
  +e.error.error-label(v-if='error') {{ error }}
  +e.globalError(v-if='globalError') {{ globalError }}
</template>

<script>

import { decodeHTMLEntities } from '@utils/helpers'

import {
  availableInfo,
} from '@utils/available_info'

import BtnsController from '@app/Purchase/BtnsController'

export default {
  name: 'GroupConfiguratorProduct',
  props: {
    item: {
      type: Object,
      required: true,
    },
    count: {
      type: Number,
      default: 0,
    },
  },
  components: {
    BtnsController,
  },
  data() {
    return {
      quantity: 0,
      username: decodeHTMLEntities(window.request_name),
      phone: window.request_phone,
      timeout: null,
      error: null,
      globalError: null,
    }
  },
  watch: {
    count: {
      immediate: true,
      handler(newVal) {
        this.quantity = newVal
      },
    },
    'item.error': {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.globalError = newVal
          // setTimeout(() => {
          //   this.error = ''
          // }, 3000)
        }
      },
    },
  },
  created() {
  },
  methods: {
    getAvailability(price) {
      const { user } = price
      return availableInfo(user.unavailable)
    },
    updateQuantity(quantity) {
      if (this.globalError && quantity < this.quantity) {
        this.globalError = null
        this.quantity = 0
        this.$emit('updateQuantity', { ...this.item, count: this.quantity })
        return
      }
      if (quantity > (this.item.stock - this.item.stock_in_cart)) {
        if (this.item.stock_in_cart) {
          this.error = `${this._('В наличии - ')} ${this.item.stock}. ${this._('В вашей корзине уже есть')} ${this.item.stock_in_cart}`
        } else {
          this.error = `${this._('Макс. кол-во товаров доступное к заказу -')} ${this.item.stock}`
        }
        setTimeout(() => {
          this.error = ''
        }, 3000)
        this.quantity = quantity
        this.$nextTick(() => {
          const q = this.item.stock - this.item.stock_in_cart
          this.quantity = 0 > q ? 0 : q
        })
        return
      }

      this.quantity = quantity
      this.$emit('updateQuantity', { ...this.item, count: quantity })
    },
    getPrice() {
      const [initialPrice] = this.item.price_definition.user.ranged_prices
      return initialPrice.sale_price || initialPrice.default_price
    },
  },
}
</script>
